import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { accessTokenKey, refreshExpiresInKey } from '../../../../helpers/local-storage';
import { concatPath } from '../../../../helpers/path';
import { validate } from '../../../../helpers/validate';
import { useKeyDown } from '../../../../hooks/use-key-down';
import { useLang } from '../../../../hooks/use-lang';
import { RootPath } from '../../../../routes/manager/manager-enums';
import { useAuthStore } from '../../../../store/use-auth-store';

export const useLogin = () => {
  const { handleChangeLang, t } = useLang();
  const { login, handleUpdateLoginData, isLoading, loginData, error, resetError } = useAuthStore();
  const navigate = useNavigate();
  const submitRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    return () => resetError();
  }, [resetError]);

  const handleLogin = async () => {
    const isValid = validate({
      username: { rule: () => !!loginData?.login },
      password: { rule: () => !!loginData?.password },
    });
    if (!isValid) return;

    try {
      const isAdmin = await login();
      if (isAdmin) {
        document.cookie = `session=${localStorage.getItem(
          accessTokenKey,
        )}; path=/; max-age=${localStorage.getItem(refreshExpiresInKey)}`;
        window.location.replace('/admin');
      } else {
        navigate(concatPath([RootPath.Manager]));
      }
    } catch (e) {
      console.error(e);
    }
  };

  useKeyDown(submitRef, 'Enter', handleLogin);

  return {
    handleChangeLang,
    t,
    handleUpdateLoginData,
    loginData,
    error,
    handleLogin,
    isLoading,
    submitRef,
  };
};
